export default __webpack_public_path__ + "static/media/PS-Logo03.b7321ce2.svg";